import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a table for future events reports.
 */
export default class TableFutureEventsReports extends JetView {
    /**
     * Configures the view.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a number as a percentage.
         * @param {number} value - The value to format.
         * @returns {string} Formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            id: 'datatable', // ID for the datatable
                            view: 'datatable', // Webix datatable view
                            scroll: 'xy', // Enable both horizontal and vertical scrolling
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                {
                                    id: 'Date', // Column ID
                                    header: _('Fecha'), // Column header with localization
                                    width: 200, // Column width
                                    format: dateFormat, // Date formatting for this column
                                },
                                {
                                    id: 'UniqueTransactionId', // Column ID
                                    header: _('Identificador único de la transacción'), // Column header
                                    width: 250, // Column width
                                },
                                {
                                    id: 'PlayerId', // Column ID
                                    header: _('Identificador único del jugador'), // Column header
                                    width: 250, // Column width
                                },
                                {
                                    id: 'PlayerName', // Column ID
                                    header: _('Nombre del jugador'), // Column header
                                    width: 350, // Column width
                                },
                                {
                                    id: 'DocumentType', // Column ID
                                    header: _('Tipo de documento'), // Column header
                                    width: 200, // Column width
                                },
                                {
                                    id: 'DocumentNumber', // Column ID
                                    header: _('Numero de documento'), // Column header with localization
                                    width: 250, // Column width
                                },
                                {
                                    id: 'TicketDate', // Column ID
                                    header: _('Fecha de ticket'), // Column header with localization
                                    width: 250, // Column width
                                    format: webix.Date.dateToStr('%d/%m/%Y %H:%i:%s'), // Date formatting for this column
                                },
                                {
                                    id: 'Bet', // Column ID
                                    header: _('Apuesta abierta'), // Column header with localization
                                    width: 250, // Column width
                                },
                            ],
                            on: {
                                /**
                                 * Event triggered before loading data.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                /**
                                 * Event triggered after loading data.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no data
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    ); // Show no data overlay
                                }
                            },
                            autowidth: false, // Disable automatic width adjustment
                            math: true, // Enable mathematical operations
                            datafetch: 10, // Number of data items to fetch at once
                            pager: 'pagerA', // ID of the pager component
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        let url = devConfig.geturlApi() + 'es/Financial/GetFutureEvents'; // API URL for fetching future events

        /**
         * Event listener for filtering future events.
         * @param {Object} filterData - The filter criteria.
         */
        this.on(this.app, 'futureEvents:filter', (filterData) => {
            let object = Object.entries(filterData); // Convert filter data to entries
            let string1 = ''; // Initialize query string

            for (let i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        let date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                        } else {
                            if (object[i][0] == 'Date') {
                                let date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        let object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (let j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    let d = new Date(object2[j][1]); // Create date object for start
                                    let dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        let d = new Date(object2[j][1]); // Create date object for end
                                        let dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            $$('consultDesk').define('disabled', true); // Disable consult desk during loading
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1) // Load data with constructed query string
                .then((response) => {
                    $$('consultDesk').define('disabled', false); // Re-enable consult desk after loading
                })
                .catch((e) => {
                    $$('consultDesk').define('disabled', false); // Re-enable consult desk on error
                });
            $$('filterPopup').hide(); // Hide filter popup
        });

        $$('pagerA').attachEvent('onAfterPageChange', function (page) {
            webix.delay(
                function () {
                    if (page != '0') {
                        chargeTable(); // Load data for the new page
                    }
                },
                '',
                '',
                100,
            );
        });

        /**
         * Event listener for changing size.
         * @param {Object} filterData - The filter criteria.
         */
        this.on(this.app, 'changeSize', (filterData) => {
            chargeTable(); // Load data when size changes
        });

        /**
         * Loads data into the grid based on pagination.
         */
        function chargeTable() {
            let size = grid.getPager().config.size; // Get page size
            let page = grid.getPage(); // Get current page
            let first = size * page; // Calculate first item index
            let last = first + size - 1; // Calculate last item index
            grid.load(url + '?start=' + first + '&count=' + (last + 1) + filter); // Load data with pagination
        }
    }
}

// FILE DOCUMENTED
